module.exports = __webpack_public_path__ + "static/guerilla-20-db3ba051c25c4b29cdc089750ca8a981.png";